import React from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/splide.min.css';
import { reviews } from './reviewsData';
import Heading from '../common/heading/Heading';
// import Quote from '../assets/blockquote.svg';

import './Testimonials.css';

const Testimonials = ({ currentPage }) => {
  const filteredReviews = reviews.filter(review => review.pages.includes(currentPage));

  return (
    <section className="testimonial-container-test">
      <div className="title-test">
        <Heading subtitle='TESTIMONIAL' title='Our Successful Students' />
      </div>

      <div className="slider-container-test">
        <blockquote>
          {/* <img className="top-quote quote" src={Quote} alt="quote" />
          <img className="bottom-quote quote" src={Quote} alt="quote" /> */}
        </blockquote>

        <Splide
          options={{
            perPage: 1,
            autoplay: true,
            speed: 1000,
            rewind: true,
            rewindByDrag: true,
          }}
        >
          {filteredReviews.map((review) => (
            <SplideSlide key={review.id}>
              <div className="image-container-test">
                <img className="image-test" src={review.image} alt={review.name} />
              </div>
            </SplideSlide>
          ))}
        </Splide>
      </div>
    </section>
  );
};

export default Testimonials;
